var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileInvoiceDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-invoice-dollar",
    d: "M12.943,3.333H10V.391ZM9.333,12V10H4v2Zm1.349,4H0V2A2,2,0,0,1,2,0H8.667V4.667h4.667v2h-2v.945a3.339,3.339,0,0,0-1.321,1.055H2.667v4.667H9.333A3.323,3.323,0,0,0,10.682,16ZM2.667,4.667H6V3.333H2.667Zm0,2.667H6V6H2.667Zm11.79,4.178-2.027-.338A.512.512,0,0,1,12,10.667.667.667,0,0,1,12.667,10H14a.667.667,0,0,1,.667.667H16a2,2,0,0,0-2-2V8H12.667v.667a2,2,0,0,0-2,2,1.841,1.841,0,0,0,1.543,1.822l2.027.338a.512.512,0,0,1,.429.507A.667.667,0,0,1,14,14H12.667A.667.667,0,0,1,12,13.333H10.667a2,2,0,0,0,2,2V16H14v-.667a2,2,0,0,0,2-2A1.841,1.841,0,0,0,14.457,11.511Z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInvoiceDollar);
export default __webpack_public_path__ + "static/media/file-invoice-dollar.1f2dd069f001f040a7b2a2a840b8c26c.svg";
export { ForwardRef as ReactComponent };